<template>
    <v-container fluid style="height: 100vh; background-color: #1A237E;">
        <v-layout
            justify-center
            align-center
            fill-height
            :pa-5="$vuetify.breakpoint.smAndUp"
            row
            align-content-center
        >
            <v-flex xs12 xl8>
                <v-layout justify-center row class="text-xs-center">
                    <h1
                        class="font-weight-thin white--text"
                        :class="{
                            'display-2': $vuetify.breakpoint.smAndDown,
                            'display-3': $vuetify.breakpoint.mdOnly,
                            'display-4': $vuetify.breakpoint.lgAndUp
                        }"
                    >
                        How would you like to set the draft teams?
                    </h1>
                </v-layout>
                <v-layout justify-center row mt-5>
                    <v-btn
                        class="indigo--text"
                        color="indigo lighten-5"
                        ripple
                        raised
                        large
                        :class="{
                            'mt-3': $vuetify.breakpoint.smAndDown,
                            'lg-btn display-2': $vuetify.breakpoint.lgOnly,
                            'xl-btn display-3': $vuetify.breakpoint.xlOnly
                        }"
                        @click="clearAndGo"
                        >Start From Scratch</v-btn
                    >
                    <!-- <v-btn
                        color="indigo darken-3"
                        ripple
                        depressed
                        round
                        large
                        @click='randomizeAndGo'
                        >Randomize Players</v-btn
                    > -->
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'TeamsChoice',
    methods: {
        clearAndGo() {
            this.$store.commit('clearTeams');
            this.$router.push('teams-edit');
        }
    }
};
</script>

<style scoped></style>
